import { defineMessages } from "react-intl";

export const scope = "components.HisotryInfiniteScroll";

export const messages = defineMessages({
  withdraws: {
    id: `${scope}.withdraws`,
    defaultMessage: "Envíos",
  },
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: "Depósitos",
  },
  dolarize: {
    id: `${scope}.dolarize`,
    defaultMessage: "Dolarización",
  },
  showMoreButton: {
    id: `${scope}.showMoreButton`,
    defaultMessage: "VER MÁS MOVIMIENTOS",
  },
});
